module.exports = __webpack_public_path__ + "static/bible.e2ed6aee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bible.jpg
// module id = 92
// module chunks = 35783957827783 82680274759079